var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "region_list" },
    [
      _c(
        "ul",
        { staticClass: "tov_select" },
        _vm._l(_vm.organizations, function (item) {
          return _c(
            "li",
            {
              class: _vm.class_org(item),
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.set_active(item)
                },
              },
            },
            [_vm._v("\n            " + _vm._s(item.text) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("user_list", { attrs: { users: _vm.userlist } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }